// Typelizer digest 854c3129f49adffd14e9c4a27af989de
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /onboarding */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/onboarding', {}, options),
    method: 'get',
  }),

  /** GET /onboarding/:step */
  show: (
    params: { step: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/onboarding/:step', params, options),
    method: 'get',
  }),

  /** PATCH /onboarding/:step */
  update: (
    params: { step: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/onboarding/:step', params, options),
    method: 'patch',
  }),
}
